import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DialogBox from "../../components/Comman/dialog-box/DialogBox";
import buttonsData from "./button.json";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationAgentCreationSchema } from "../../components/Ai-Saas/CreateAIData/fieldsConfig";
import { FormControl } from "react-bootstrap";
import { ExpandLess, ExpandMore, Label } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  createAgent,
  deleteAgentById,
  getAiAgentById,
  getAllAiAgentDetails,
  updateAgentById,
} from "../../redux/actions/ai_functions";
import { v4 as uuidv4 } from "uuid"; // Optionally use uuid for unique IDs
import CardWithButton from "../../components/Comman/button-new";


export default function CreateAiTable(props) {
  const [agentCreationModelOpen, setAgentCreationModelOpen] =
    React.useState(false);
  const [eligiblePaymentMode, setEligiblePaymentMode] = React.useState(true);
  const [createdAgentsData, setCreatedAgentsData] = React.useState([]);
  const [updatingAgent, setUpdatingAgent] = React.useState(false);
  const [updatingAgentId, setUpdatingAgentId] = React.useState("");
  const [viewModalOpen, setViewModalOpen] = React.useState(false);
  const [selectedMethods, setSelectedMethods] = React.useState([]);
  const paymentMethods = ["razorpay", "payU"];
  const { setShowDialog, activeTab, setActiveTab } = props;

  const aiAgentDataById = useSelector(
    (state) => state?.aiDataReducer?.aiAgentDataById
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationAgentCreationSchema),
    defaultValues: {
      name: "",
      url: "",
      active_payment_mode: "",
      eligible_payment_mode: [],
    },
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const dispatch = useDispatch();

  const handleClose = () => {
    setAgentCreationModelOpen(false);
    setValue("active_payment_mode", "");
    setSelectedMethods([]);
    setValue("eligible_payment_mode", []);
    setValue("name", "");
    setValue("url", "");
    if (updatingAgent === true) {
      setUpdatingAgent(false);
      setUpdatingAgentId("");
    }
    setEligiblePaymentMode(true)
  };

  function handleEditClick(id) {
    setAgentCreationModelOpen(true);
    const selectedRowData = createdAgentsData.find((row) => row?.id === id);
    setUpdatingAgent(true);
    setUpdatingAgentId(selectedRowData?.id);
    setSelectedMethods(selectedRowData?.eligible_payment_mode);
    setValue("eligible_payment_mode", selectedRowData?.eligible_payment_mode);
    setValue("name", selectedRowData?.name);
    setValue("url", selectedRowData?.url);
    setValue("active_payment_mode", selectedRowData?.active_payment_mode);
  }

  const handleChange = (method) => {
    setSelectedMethods((prev) => {
      const newMethods = prev?.includes(method)
        ? prev.filter((m) => m !== method)
        : [...prev, method];

      setValue("eligible_payment_mode", newMethods);

      return newMethods;
    });
  };

  console.log(errors, "errors");

  const onFormSubmit = async (data) => {
    const { active_payment_mode, name, url, eligible_payment_mode } = data;
    const recreatedSchema = {
      active_payment_mode,
      eligible_payment_mode,
      name,
      url,
    };
    if (updatingAgentId) {
      const data = { updatingAgentId, recreatedSchema };
      dispatch(updateAgentById(data));
    } else {
      dispatch(createAgent(recreatedSchema));
    }
    setAgentCreationModelOpen(false);
    setValue("active_payment_mode", "");
    setValue("eligible_payment_mode", []);
    setValue("name", "");
    setSelectedMethods([]);
    setValue("url", "");
  };

  React.useEffect(() => {
    // Whenever selectedMethods updates, update eligible_payment_mode in form data
    setValue("eligible_payment_mode", selectedMethods);

    // Check if active_payment_mode is still valid, otherwise clear it
    if (!selectedMethods.includes(watch("active_payment_mode"))) {
      setValue("active_payment_mode", "");
    }
  }, [selectedMethods, setValue, watch]);

  const { allAgentDetails } = useSelector((state) => state?.aiDataReducer);

  React.useEffect(() => {
    if (allAgentDetails?.length > 0) {
      const allData = allAgentDetails?.map((item) => ({
        ...item,
        id: item?.ai_id || uuidv4(),
        name: item?.name,
        url: item?.url,
      }));
      setCreatedAgentsData(allData);
    }
  }, [allAgentDetails]);

  React.useEffect(() => {
    const token = localStorage.getItem("token")
    setTimeout(() => {
      if (token) dispatch(getAllAiAgentDetails());
    }, 1000);
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Agent Name",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "url",
      headerName: "Url",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={() => {
                setViewModalOpen(true);
                dispatch(getAiAgentById(params.row.id));
              }}
              color="primary"
              title="View"
            >
              <VisibilityIcon />
            </IconButton>
            <IconButton
              onClick={() => handleEditClick(params.row.id)}
              color="info"
              title="Edit"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                dispatch(deleteAgentById(params.row.id));
              }}
              color="error"
              title="Delete"
              disabled
            >
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleModal = () => {
    setAgentCreationModelOpen(() => !agentCreationModelOpen);
  }

  return (
    <>
      <Box style={{ margin: "0px 0px 40px 0px" }}>
        <CardWithButton
          title="Create Your Agent Here"
          className=""
          buttonLabel="Create Agent"
          buttonIcon={<AddIcon />}
          buttonClick={() => handleModal(true)}
        />

      </Box>
      <>
        <Box sx={{ height: 500, width: "98%", backgroundColor: "#fff", borderRadius: "10px", padding: "10px" }}>
          <DataGrid
            rows={createdAgentsData}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
            disableDensitySelector
            sx={{
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-cell": {
              },
            }}
          />
        </Box>
      </>
      <Modal
        open={agentCreationModelOpen}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <Grid
            sx={{
              ...style,
              width: 600,
              // height: 700,
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignContent: "center",
              borderRadius: "10px"
            }}
          >
            <h3 style={{ textAlign: "center", margin: "10px 0px" }}>
              {updatingAgent ? "Update Agent" : "Create Agent"}
            </h3>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Agent Name"
                    {...field}
                    error={!!errors.name}
                    helperText={errors.name?.message || ""}
                    margin="normal"
                    className="w-100"
                  />
                )}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Button
                      variant="contained"
                      style={{ padding: "16px 10px", margin: "14px 0px" }}
                      onClick={() =>
                        setEligiblePaymentMode(() => !eligiblePaymentMode)
                      }
                    >
                      <span>Eligible Payment Mode</span>
                      &nbsp;
                      {!eligiblePaymentMode ? <ExpandLess /> : <ExpandMore />}
                    </Button>
                    {errors?.eligible_payment_mode &&
                      errors?.eligible_payment_mode && (
                        <span className="fs-6 text-danger">
                          {errors?.eligible_payment_mode?.message}
                        </span>
                      )}
                  </div>
                  <Box sx={{ display: eligiblePaymentMode ? "none" : "flex" }}>
                    <Controller
                      name="eligible_payment_mode"
                      control={control}
                      render={({ field }) => (
                        <FormGroup type="string">
                          {paymentMethods.map((method, index) => (
                            <MenuItem key={index}>
                              <>
                                <FormControlLabel
                                  {...field}
                                  label={method}
                                  control={
                                    <Checkbox
                                      checked={
                                        selectedMethods.includes(method)
                                          ? true
                                          : false
                                      }
                                      name={method}
                                      onChange={() => {
                                        handleChange(method);
                                        clearErrors("eligible_payment_mode");
                                      }}
                                    />
                                  }
                                />
                              </>
                            </MenuItem>
                          ))}
                        </FormGroup>
                      )}
                    />
                  </Box>
                </div>
                <Controller
                  name={`active_payment_mode`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="number"
                      select
                      label={"Active Payment Mode"}
                      margin="normal"
                      className="w-50"
                      error={
                        !!errors.active_payment_mode &&
                        errors.active_payment_mode
                      }
                      helperText={
                        errors.active_payment_mode &&
                        errors.active_payment_mode?.message
                      }
                    >
                      {selectedMethods.map((method, index) => (
                        <MenuItem key={index + 1} value={method}>
                          {method}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </div>
              <Controller
                name="url"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Url"
                    {...field}
                    error={!!errors.url}
                    helperText={errors.url?.message || ""}
                    margin="normal"
                    className="w-100"
                  />
                )}
              />
            </Box>
            <Box sx={{ margin: "20px 0px" }}>
              <Button
                style={{ width: "100%" }}
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </form>
      </Modal>{" "}
      {/* view ai agent by id */}
      <Modal
        open={viewModalOpen}
        onClose={() => {
          if (viewModalOpen === true) {
            setViewModalOpen(false);
          }
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Grid
          sx={{
            ...style,
            width: 600,
            height: 400,
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignContent: "center",
          }}
        >
          <h3 style={{ textAlign: "center", margin: "20px 0px" }}>
            Agent Data
          </h3>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <span>Agent Name: {aiAgentDataById?.name}</span>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Button
                    variant="contained"
                    style={{ padding: "16px 10px", margin: "14px 0px" }}
                    onClick={() =>
                      setEligiblePaymentMode(() => !eligiblePaymentMode)
                    }
                  >
                    <span>Eligible Payment Mode</span>
                    &nbsp;
                    {!eligiblePaymentMode ? <ExpandLess /> : <ExpandMore />}
                  </Button>
                </div>
                <Box sx={{ display: eligiblePaymentMode ? "none" : "flex" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {aiAgentDataById?.eligible_payment_mode?.map(
                      (method, index) => {
                        return <span key={index}>{method}</span>;
                      }
                    )}
                  </div>
                </Box>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontWeight: "bold" }}>Active Payment Mode</span>
                <span>{aiAgentDataById?.active_payment_mode}</span>
              </div>
            </div>
            <span>URL: {aiAgentDataById?.url}</span>
          </Box>
        </Grid>
      </Modal>
    </>
  );
}
